import { createContext } from "react";
import FeatureFlagManager from "./featureFlagManager";

const FeatureFlagManagerContext = createContext<FeatureFlagManager>(
    new FeatureFlagManager(),
);

export default FeatureFlagManagerContext;
